import type { UserClubRole } from '../types/common';

import useGetCurrentClub from './useGetCurrentClub';

const useCheckUserClubRole = (clubId: string | number, roles: UserClubRole[]) => {
  const club = useGetCurrentClub(`${clubId}`);
  const roleForUser = club?.roleForUser;
  const matchedRole = roles.some((role) => roleForUser === role);

  return matchedRole;
};

export default useCheckUserClubRole;
